const topicItems = [
  { id: 1, name: '暑期档推荐', count: '2.3万讨论', hot: true },
  { id: 2, name: '豆瓣高分榜', count: '1.8万讨论', hot: true },
  { id: 3, name: '科幻片天花板', count: '1.5万讨论', hot: true },
  { id: 4, name: '烧脑神作合集', count: '1.2万讨论', hot: false },
  { id: 5, name: '催泪弹预警', count: '1.1万讨论', hot: false },
  { id: 6, name: '周末宅家片单', count: '9800讨论', hot: false },
  { id: 7, name: '港片黄金时代', count: '8600讨论', hot: false },
  { id: 8, name: '韩国电影TOP', count: '7400讨论', hot: false },
  { id: 9, name: '纪录片精选', count: '6200讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-200 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-hashtag mr-1"></i>热议话题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">加入影迷社区，参与热门电影话题讨论</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className={`group flex items-center gap-2.5 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-200 ${
                item.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200 border border-secondary-200'
              }`}
            >
              {item.hot && <i className="ri-fire-line text-accent-500 text-sm"></i>}
              <span className="text-sm font-medium whitespace-nowrap">#{item.name}</span>
              <span className={`text-xs whitespace-nowrap ${item.hot ? 'text-primary-500' : 'text-secondary-500'}`}>{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}